import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { AlertStyleDirective } from '../../../directives/alert-style.directive';
import { DividerModule } from 'primeng/divider';
import { ImportPreviewBoxComponent } from '../import-preview-box/import-preview-box.component';
import { KeyValuePipe, NgForOf, NgIf } from '@angular/common';
import { PanelModule } from 'primeng/panel';
import { GlobalsStore } from '../../../stores/globals.state';
import { ImportDataValidation } from '../../../models/import-data';
import { Severity } from '../../../models/severity';
import { getState } from '@ngrx/signals';
import { DataLayerType } from '../../../models/data-layer-type';
import { HeaderComponent } from '../../atoms/header/header.component';
import { ChipModule } from 'primeng/chip';

@Component({
  selector: 'app-import-validation-result-data',
  standalone: true,
  imports: [
    AlertStyleDirective,
    DividerModule,
    ImportPreviewBoxComponent,
    KeyValuePipe,
    NgForOf,
    NgIf,
    PanelModule,
    HeaderComponent,
    ChipModule,
  ],
  templateUrl: './import-validation-result-data.component.html',
  styleUrl: './import-validation-result-data.component.scss',
})
export class ImportValidationResultDataComponent {
  readonly globalStore = inject(GlobalsStore);
  selectedType: DataLayerType | null = null;
  @Input() importValidationResult!: ImportDataValidation;
  @Output() itemsToShow: EventEmitter<Severity> = new EventEmitter();

  validationPreviewSeverities: Severity[] = [
    'success',
    'info',
    'warning',
    'error',
    'lock',
    'secondary',
  ];

  constructor() {
    const globalState = getState(this.globalStore);
    this.selectedType = globalState.selectedType;
  }

  /**
   * Sets the items to show based on the given severity and emits the updated severity value.
   *
   * @param {Severity} severity - The severity level used to filter and display items.
   * @return {void} Does not return a value.
   */
  setItemsToShow(severity: Severity): void {
    this.itemsToShow.emit(severity);
  }
}
